var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details_content_repeat"},[_c('QS-h4-title',{attrs:{"title":"支付信息"}}),_vm._v(" "),_c('div',{staticClass:"details_content_repeat_hundred"},[_c('column-box',{attrs:{"source":_vm.source,"list":_vm.payInfoList,"label-width":"140"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }